(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autumn-event-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialize = (scope) => {
      const popup = scope.querySelector('[data-autumn-entry]');
      if (!popup || popup.dataset.initialized) return;
      popup.dataset.initialized = 'true';
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const end = Date.parse(popup.dataset.end);
      let timer;
      let expiryTimer;
      const onEscape = (event) => {
        if (event.key === 'Escape' && popup.open) popup.hide();
      };
      const expire = () => {
        if (Number.isFinite(end) && Date.now() < end) return;
        clearTimeout(timer);
        clearTimeout(expiryTimer);
        if (popup.open) popup.hide();
        document.removeEventListener('keydown', onEscape);
        document.removeEventListener('visibilitychange', expire);
      };
      document.addEventListener('keydown', onEscape);
      document.addEventListener('visibilitychange', expire);
      const section = popup.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => {
        clearTimeout(timer);
        clearTimeout(expiryTimer);
        document.removeEventListener('keydown', onEscape);
        document.removeEventListener('visibilitychange', expire);
      }, { once: true });
      if (!Number.isFinite(end) || Date.now() >= end) {
        expire();
        return;
      }
      expiryTimer = setTimeout(expire, end - Date.now());
      customElements.whenDefined('pop-in').then(() => {
        timer = setTimeout(() => {
          if (!popup.isConnected || !Number.isFinite(end) || Date.now() >= end) return;
          if (document.visibilityState !== 'visible' && !designMode) return;
          popup.show();
        }, Number(popup.dataset.delay || 0) * 1000);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autumn-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const expireOffers = () => {
      document.querySelectorAll('[data-autumn-grid-root]').forEach((grid) => {
        const end = Date.parse(grid.dataset.offerEnd);
        if (!Number.isFinite(end) || Date.now() < end) return;
        grid.querySelectorAll('[data-autumn-grid-offer]').forEach((item) => { item.hidden = true; });
        grid.querySelectorAll('[data-autumn-grid-standard], [data-autumn-grid-ended]').forEach((item) => { item.hidden = false; });
      });
    };
    expireOffers();
    document.addEventListener('shopify:section:load', expireOffers);
    document.addEventListener('visibilitychange', expireOffers);
    window.setInterval(expireOffers, 60000);
  })();

  } catch(e) { console.error(e); }
})();
})();
